import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/da/trip/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/trip/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const loadDailyTrips = (params, urlParams) => {
  return axios.request({
    url: '/da/trip/loaddailytrips/' + params.terminalNum + '/' + params.selectDatetime + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const loadComplexTripsByStartDatetime = (params, urlParams) => {
  return axios.request({
    url: '/da/trip/loadcomplextripsbystartdatetime/' + params.terminalNum + '/' + params.startDatetime + '/' + params.endDatetime + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDailyReport = (params, urlParams) => {
  return axios.request({
    url: '/da/trip/getdailyreport/' + params.terminalNum + '/' + params.selectDatetime + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

